module.exports = "<!-- angly Menu -->\n<div angly-menu></div>\n"